import { useLocation, useNavigate } from 'react-router-dom';
import { processDemoPayment } from '../components/DbServices';
import Layout from '../layout/Layout';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function Checkout() {
  const { state } = useLocation(); // Receives plan details from Pricing page
  const navigate = useNavigate();
  const user = getStoredUser();
  const userId = user?.data?.id;

  if (!state?.plan) {
    return <Layout><div className="p-5 text-center">No plan selected.</div></Layout>;
  }

  const { plan } = state;

  const handleDemoPayment = async () => {
    const res = await processDemoPayment(userId, plan.id);
    if (res.status === 200) {
      navigate('/payment-success', { state: { planName: plan.name } });
    } else {
      Swal.fire("Payment Error: " + res.error);
    }
  };

  return (
    <Layout>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="card border-0 shadow-lg p-4">
              <h4 className="fw-bold mb-4">Checkout</h4>
              <div className="bg-light p-3 rounded mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span>Plan:</span>
                  <span className="fw-bold">{plan.name}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span>Duration:</span>
                  <span>{plan.duration_days} Days</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between align-items-center">
                  <span className="h5 mb-0">Total:</span>
                  <span className="h4 mb-0 text-primary">Rs.{plan.price}</span>
                </div>
              </div>

              <div className="Swal Swal-warning small">
                <i className="fas fa-flask me-2"></i>
                This will submit your <strong>Request</strong>. Your plan will be activated within 24-48 hours after our team reviews your request. 
              </div>

              <button 
                className="btn btn-primary btn-lg w-100 shadow-sm mt-3" 
                onClick={handleDemoPayment}
              >
                 Activate Plan
              </button>
              
              <button className="btn btn-link w-100 text-muted mt-2" onClick={() => navigate(-1)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}